// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"9ec085ed","375":"8f261d31"}[chunkId] + ".chunk.css";
};